import { render, staticRenderFns } from "./FeaturesSection.vue?vue&type=template&id=50dcef41&scoped=true"
import script from "./FeaturesSection.vue?vue&type=script&lang=js"
export * from "./FeaturesSection.vue?vue&type=script&lang=js"
import style0 from "./FeaturesSection.vue?vue&type=style&index=0&id=50dcef41&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50dcef41",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.ideabuddy.com/public_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50dcef41')) {
      api.createRecord('50dcef41', component.options)
    } else {
      api.reload('50dcef41', component.options)
    }
    module.hot.accept("./FeaturesSection.vue?vue&type=template&id=50dcef41&scoped=true", function () {
      api.rerender('50dcef41', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Payment/Components/Sections/Features/FeaturesSection.vue"
export default component.exports